import { useState } from "react"
import Select from 'react-select'

export default function AssetSelect (props) {
  const [ddStyle, setDDStyle] = useState('dropdown')

  return (
    <>
      <label className="col-sm-3 col-form-label">{props.title}</label>
      <div className="col-sm-3">
        <Select 
          id={props.name}
          key={props.name}
          name={props.name}
          options={props.options}
          onChange={props.onChange}
          className={ddStyle}
          onFocus={() => setDDStyle('bottom-dd')}
          onBlur={() => setDDStyle('dropdown')}
          maxMenuHeight={props.maxHeight}
          placeholder={props.placeholder}
          value={props.value}
          required
        />
      </div>
  </>
  )
}